<template>
  <div class="status_1_content" >
    <div class="status_1_content_content" v-loading="vLoading">
      <div >
      <div class="contentItem questionMatter" v-if="currentValue.type == 3">
        <question :questionId="currentValue.id"></question>
      </div>
      <div class="type6style" v-else-if="currentValue.type === 6">
        <div
          class="type6Item"
          v-for="(item, index) in currentValue.imageText"
          :key="index"
          :style="item.style"
          :ref="'scroll' + item.sort"
          v-if="item"
        >
          <div class=" editorShowArea ql-editor zl-editor" v-html="item.value" v-if="item.type === 1"></div>
          <answer @submitAnswer="submitAnswer" :answerList="answerList" v-if="item.type === 3 && (hasQuestionTypeId(item) == 1||hasQuestionTypeId(item) == 2 || hasQuestionTypeId(item) == 3 )" v-model="item.valueObj.questionContent"></answer>
          <operation v-else-if="item.type === 3" :item="item" @handleGoStudy="handleGoStudy" @addEventObj="addEventObj" :questionId="item.value" :questionTypeId="hasQuestionTypeId(item)"></operation>

          <img v-else-if="item.type === 7" class="type6resouce" :src="item.value" />
          <video
            v-else-if="item.type === 10"
            class="video-js type6resouce"
            controls
            preload="auto"
            controlslist="nodownload"
            data-setup="{'example_option':true}"
            :ref="'zl_edit_video' + index"
          >
            <source :src="item.value" type="video/mp4" class="video" />
            <p class="vjs-no-js">不支持播放</p>
          </video>
          <code-compiler readPage readOnly ref="codeCompiler" :refresh="item.value" v-else-if="item.type === 11" v-model="item.value"></code-compiler>
<!--          <div-->
<!--            v-if="isShow"-->
<!--            style="text-align: right;padding-right: 50px;margin-top: 7px">-->
<!--            <el-button v-if="item.type === 3 && filtersIsShow(item)" size="mini" @click="handleGoStudy(item)">去实操</el-button>-->
<!--            <el-button v-else-if="item.type === 11 && filtersIsShow(item)" size="mini" @click="handleGoStudy(item)">试一下</el-button>-->
<!--          </div>-->
          <div
            v-if="isShow"
            style="text-align: right;padding-right: 50px;margin-top: 7px">
            <!-- <el-button v-if="item.type === 3 && (hasQuestionTypeId(item) != 1&&hasQuestionTypeId(item) != 2&&hasQuestionTypeId(item) != 3)" size="mini" @click="handleGoStudy(item)">去实操</el-button> -->
            <div class="btn" v-if="item.type === 11 && item.extendOption && item.extendOption.operationIsShow" size="mini" @click="handleGoStudy(item)">试一下</div>
          </div>
        </div>
      </div>
      <img
        class="status_1_content_resouce contentItem"
        v-else-if="currentValue.type == 7"
        :src="currentValue.newAttaUrl"
      />
      <video
        v-else-if="currentValue.type == 10"
        class="contentItem video-js status_1_content_resouce"
        controls
        preload="auto"
        controlslist="nodownload"
        data-setup="{'example_option':true}"
        ref="newCourseVideo"
      >
        <source
          v-if="currentValue.type == 10"
          :src="currentValue.newAttaUrl"
          type="video/mp4"
          class="video"
        />
        <p class="vjs-no-js">不支持播放</p>
      </video>
    </div>
    </div>
  </div>
</template>

<script>
/**
 *  内容展示
 **/
import codeCompiler from "./code_compiler";
import operation from './operation.vue';
import answer from './answer.vue';
import bus from '../../bus/bus';
import option from "../single_resource_course/js/option";
export default {
  name: "status_1_content",
  props: {
    value: {
      type: Object,
      default: () => {},
    },
    isShow:{
      type:Boolean,
      default:false,
    },
    answerList:{
      type: Array,
      default:()=>[{}]
    }
  },
  components: {
    codeCompiler,
    operation,
    answer
  },
  data() {
    return {
      currentValue: this.value,
      courseName: this.$route.query.courseName,
      option:option,
      vLoading: false,
    };
  },
  watch: {
    value: {
      handler(val) {
        if (val) {
          this.currentValue = val;
          if (val.type === 6 && val.imageText) {
            try {
              let imageText = JSON.parse(val.imageText);
              [].forEach.call(imageText, imageTextitem =>{
                if(imageTextitem == null){
                  return
                }
                let o = this.option.filter(optionitem =>{
                  return imageTextitem.type === optionitem.type
                })[0]
                if (imageTextitem.extendOption){
                }else{
                  this.$set(imageTextitem, 'extendOption', o.extendOption);
                }
              })
              this.$set(this.currentValue, 'imageText', imageText);
            } catch (e) {}
          }
        }
      },
      immediate: true,
      deep: true,
    },
  },
  mounted() {
    if (this.$refs.codeCompiler){
      this.vLoading = true;
     let timer = setTimeout(()=>{
        [].forEach.call(this.$refs.codeCompiler, ref =>{
          ref.coder.refresh()
        })
        this.vLoading = false;
       clearTimeout(timer);
      }, 500);
    }
    bus.$on('goIndexes', this.goIndexes)
    this.isScrollBottom()
  },
  methods: {
      isScrollBottom(){
        this.$nextTick(() => {
        const el = document.querySelector(".status_1_content");
        const offsetHeight = el.offsetHeight;
        el.onscroll = () => {
          const scrollTop = el.scrollTop;
          const scrollHeight = el.scrollHeight;
          if (offsetHeight + scrollTop - scrollHeight >= 0) {
            // console.log("到达底部")
            this.$emit('judgeIsDown')
          }
        };
      });
    },
    // http://127.0.0.1:12221/api-resource/code/data/getByTargetId?targetId=23440&targetType=1
    addEventObj(obj){
      this.$emit('addEventObj', obj)
    },
    submitAnswer(val){
      this.$emit('submitAnswer',val)
    },
    handleGoStudy(item){
        this.$emit('handleGoStudy', item)
    },
    hasQuestionTypeId(item){
      if(Object.keys(item).indexOf('valueObj') == -1){
        return -1
      }
      if(Object.keys(item.valueObj).indexOf('questionContent') == -1){
        return -1
      }
      if(Object.keys(item.valueObj.questionContent).indexOf('internalTypeId') == -1){
        return -1
      }
      if(Object.keys(item.valueObj.questionContent).indexOf('check') == -1 && item.valueObj.questionContent.internalTypeId == 2){
        item.valueObj.questionContent.check = []
        console.log('aaa')
        return -1
      }
      return item.valueObj.questionContent.internalTypeId
    },
    filtersIsShow(item){
      let bol = false
      if(Object.keys(item).indexOf('extendOption') == -1){
        return false
      }
      if(Object.keys(item.extendOption).indexOf('operationIsShow') != -1){
        if(item.extendOption.operationIsShow === '1'){
          bol = true
        }
      }else if(Object.keys(item.extendOption).indexOf('codeBlock') != -1){
        if(item.extendOption.codeBlock === '1'){
          bol = true
        }
      }else{

      }
      return bol
    },
    goIndexes(o){
      if (
        eval("this.$refs.scroll" + o.sort) &&
        eval("this.$refs.scroll" + o.sort).length
      ) {
        let length = eval("this.$refs.scroll" + o.sort).length;
        eval("this.$refs.scroll" + o.sort)[length - 1].scrollIntoView({
          behavior: "smooth", // 平滑过渡
          block: "center", // 上边框与视窗顶部平齐。默认值
        });
      }
    }
  },
};
</script>

<style scoped lang="scss">
.status_1_content {
  width: 100%;
  user-select: text;
  height: 100%;
  padding-right: 10px;
  overflow: auto;
  &::-webkit-scrollbar {
     width: 0 !important;
   }
   &::-webkit-scrollbar {
     width: 0 !important;height: 0;
   }
  .status_1_content_content {
    width: 100%;
    height: 100%;
    position: relative;
    .contentItem {
      position: absolute;
      top: 45%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
    .status_1_content_resouce {
      max-height: 100%;
      min-height: 450px;
      max-width: 80%;
    }
    .type6style {
      padding: 2% 0;
      width: 100%;
      .type6Item {
        margin-bottom: 7px;
        width: 100%;
        overflow: hidden;
      }
      .type6resouce {
        display: inline-block;
        max-width: 80%;
        min-height: 350px;
        max-height: 450px;
      }
    }

    .questionMatter {
      max-width: 100%;
      max-height: 100%;
      overflow: auto;
    }
  }
}
.btn{
    width: 73px;
    height: 30px;
    line-height: 30px;
    margin-right: 30px;
    text-align: center;
    border-radius: 2px;
    font-size: 12px;
    font-family: PingFangSC-Semibold, PingFang SC;
    font-weight: 600;
    color: #fff;
    background: linear-gradient(90deg, #007CFF 0%, #00C5FF 100%);
    text-decoration: none;
    cursor: pointer;
}
</style>

<style>
  .ql-tooltip{
    display: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/component/zlItCourseEdit_show_status_1_content.vue